module.exports = __webpack_public_path__ + "img/1542540793.7897bf34.jpg";